
import axios from 'axios';
import { Loading, Notification } from 'element-ui'
import Cookies from 'js-cookie';
import parser from 'ua-parser-js';
import _props from '../../../props'

let _domain = (/(dev.|test.)?yitong.com(:\d+)?/.exec(location.host) || [])[0];
let _YitongToken = {
  domain: _domain,
  tokenKey: 'YitongToken@' + (_domain || ''),
  get: function () {
    return Cookies.get(_YitongToken.tokenKey) || '';
  },
  set: function (token) {
    return Cookies.set(_YitongToken.tokenKey, token || '', {
      expires: 30,
      domain: _YitongToken.domain,
      path: '/'
    });
  }
}

function _getToken() {
  return _YitongToken.get()
}

function _toLogin() {
  location.href = '/login?back=' + location.href
}

// 创建axios实例
let requestCount = 0
let requestList = []
// 取消请求
const CancelToken = axios.CancelToken
const source = CancelToken.source()

let inWhiteList = /\/login|\/login.html$/.test(location.pathname)

const YT = Object.assign(window.YT || {}, {
  showLoading: () => {
    Loading.service({
      fullscreen: true
    })
  },
  hideLoading: () => {
    Loading.service({
      fullscreen: true
    }).close()
  },
  showToast: msg => {
    Notification.success({
      title: '提示',
      message: msg
    })
  },
  showInfoToast: msg => {
    Notification.info({
      title: '提示',
      message: msg
    })
  },
  showErrorToast: msg => {
    Notification.error({
      title: '提示',
      message: msg
    })
  },
  hideToast: () => {
    Notification.closeAll()
  },
  // 防抖
  addHash: hash => {
    hash && requestList.push(hash)
  },
  removeHash: hash => {
    setTimeout(() => {
      hash && requestList.splice(requestList.findIndex(item => item === hash), 1)
    }, 301)
  },
  clearHash: () => {
    setTimeout(() => { requestList = [] }, 1000)
  }
})

let _axios = axios.create({
  baseURL: _props.apiBase || ('//api.' + (_domain || 'dev.yitong.com') ),
  timeout: 60000,
  headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'X-YT-AppKey': _props.appKey || ''
  },
  responseType: 'json'
});

// request拦截
_axios.interceptors.request.use((config) => {
  config._hash = config.url + JSON.stringify(config.params || {}) + JSON.stringify(config.data || {})
  if (requestList.indexOf(config._hash) > -1) {
    console.log(config._hash)
    YT.showInfoToast('请勿重复操作！')
    config.cancelToken = source.token
    return config
  } else {
    YT.addHash(config._hash)
  }
  requestCount++
  if (config.showLoading) {
    YT.showLoading()
  }
  const params = {}
  const token = _getToken()
  const isGet = config.method === 'get'
  token && (config.headers['Authorization'] = 'Bearer ' + token)
  token && (params.token = token)
  isGet && (params._t = Date.parse(new Date()) / 1000)
  config.params = {
    ...params,
    ...config.params
  }
  return config
},(error) => {
  console.log(error)
  YT.hideLoading()
  YT.showErrorToast(error)
  YT.clearHash()
  return Promise.reject(error)
})

// response拦截
_axios.interceptors.response.use(res => {
  requestCount--
  if (res.config.showLoading) {
    if (requestCount <= 0) {
      YT.hideLoading()
    } else {
      YT.showLoading()
    }
  }
  const retCode = res.data.code
  YT.removeHash(res.config._hash)
  if (retCode === 1) {
    if (res.config.showToast) {
      YT.showToast(res.data.message)
    }
    return res.data
  } else {
    if (retCode === 100 && !inWhiteList) {
      localStorage.clear()
      Cookies.remove()
      _toLogin()
    }
    YT.showErrorToast(res.data.message)
    return Promise.reject(res.data)
  }
}, function(error) {
  console.log('err ' + error)
  YT.hideLoading()
  YT.showErrorToast(error)
  YT.clearHash()
  return Promise.reject(error)
});

export const $http = _axios
export const YitongToken = _YitongToken
export const props = _props
export const domain = _domain || ''
export function toLogin(){
  return _toLogin
}
export const ua = parser(navigator.userAgent);
export const kernel = (function() {
  var agent = navigator.userAgent.toLowerCase();
  var regStr_ie = /msie [\d.]+;/gi;
  var regStr_ff = /firefox\/[\d.]+/gi;
  var regStr_chrome = /chrome\/[\d.]+/gi;
  var regStr_saf = /safari\/[\d.]+/gi;
  var result = null;
  //IE
  if (agent.indexOf('msie') > 0) {
    result = agent.match(regStr_ie);
  }
  //firefox
  if (agent.indexOf('firefox') > 0) {
    result = agent.match(regStr_ff);
  }
  //Chrome
  if (agent.indexOf('chrome') > 0) {
    result = agent.match(regStr_chrome);
  }
  //Safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    result = agent.match(regStr_saf);
  }
  return result[0].replace(' ', '/');
})();